import styled from "@emotion/styled";
import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import MaskedInput from "react-text-mask";

const CssTextField = styled(TextField)({
  "& .MuiFilledInput-root": {
    overflow: "hidden",
    borderRadius: 4,
	  width:"100%", 
    paddingBlock: "5px",
    fontFamily: "'Telefonica', sans-serif",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
    "&.Mui-focused": {
      border: "1px solid #019df4",
      color: "#0b2739",
    },
    "& fieldset": {
      border: "1px solid #019df4",
      color: "#0b2739",
    },
  },
});

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props) {
  const { ref, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={props.mask}
      guide={false}
      ref={ref}
      overwrite
      keepCharPositions
    />
  );
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalSeparator=","
      isAllowed={(values) => {
        const { value } = values;
        return value.length < 11;
      }}
      thousandSeparator="."
      valueIsNumericString
      prefix=""
    />
  );
});

const InputNumberForm = ({
  inputRef,
  icon,
  label = "",
  type = "text",
  value = null,
  handleChange,
  helperText = "",
  error = false,
  onFocus,
  mask = [],
  placeholder = null,
}) => {
  return (
    <CssTextField
      sx={{
        "& label.Mui-focused": {
          color: error ? "#d32f2f !important" : "#019df4 !important",
        },
        "& label": {
          color: error ? "#d32f2f !important" : "#86888c !important",
          marginTop: "5px",
        },
        "& .MuiFilledInput-root": {
          border: "1px solid",
          borderColor: error ? "#d32f2f" : "#b6b7b7",
        },
      }}
      ref={inputRef}
      value={value}
      onChange={handleChange}
      name="textmask"
      id="formatted-text-mask-input"
      label={label}
      variant="filled"
      error={error}
      onFocus={onFocus}
      type="tel"
      inputRef={inputRef}
      placeholder={placeholder}
      InputProps={{
        endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
        disableUnderline: true,
        inputProps: {
          mask: mask,
        },
        inputRef: inputRef,
        inputComponent:
          type === "document" ? NumericFormatCustom : TextMaskCustom,
      }}
      fullWidth
      size="small"
      helperText={error ? helperText : ""}
    />
  );
};

export default InputNumberForm;
